// @generated by protobuf-ts 2.9.0 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "permissions.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "./google/protobuf/timestamp";
/**
 * @generated from protobuf message CreateDefaultPermissionGroupRequest
 */
export interface CreateDefaultPermissionGroupRequest {
    /**
     * @generated from protobuf field: string customerID = 1;
     */
    customerID: string;
}
/**
 * @generated from protobuf message PermissionGroupResponse
 */
export interface PermissionGroupResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string customerID = 2;
     */
    customerID: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: bool accessEverything = 5;
     */
    accessEverything: boolean;
    /**
     * @generated from protobuf field: bool isDefault = 6;
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: repeated string rooms = 7;
     */
    rooms: string[];
    /**
     * @generated from protobuf field: repeated string desks = 8;
     */
    desks: string[];
    /**
     * @generated from protobuf field: repeated string locations = 9;
     */
    locations: string[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp createdAt = 10;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updatedAt = 11;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool deskBookingEnabled = 12;
     */
    deskBookingEnabled: boolean;
    /**
     * @generated from protobuf field: bool roomBookingEnabled = 13;
     */
    roomBookingEnabled: boolean;
}
/**
 * @generated from protobuf message WorkplaceLocation
 */
export interface WorkplaceLocation {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message PermissionGroupDetailedResponse
 */
export interface PermissionGroupDetailedResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string customerID = 2;
     */
    customerID: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: bool accessEverything = 5;
     */
    accessEverything: boolean;
    /**
     * @generated from protobuf field: bool isDefault = 6;
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: repeated WorkplaceLocation rooms = 7;
     */
    rooms: WorkplaceLocation[];
    /**
     * @generated from protobuf field: repeated WorkplaceLocation desks = 8;
     */
    desks: WorkplaceLocation[];
    /**
     * @generated from protobuf field: repeated WorkplaceLocation locations = 9;
     */
    locations: WorkplaceLocation[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp createdAt = 10;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updatedAt = 11;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool deskBookingEnabled = 12;
     */
    deskBookingEnabled: boolean;
    /**
     * @generated from protobuf field: bool roomBookingEnabled = 13;
     */
    roomBookingEnabled: boolean;
}
/**
 * @generated from protobuf message ListPermissionGroupsRequest
 */
export interface ListPermissionGroupsRequest {
    /**
     * @generated from protobuf field: string customerID = 1;
     */
    customerID: string;
}
/**
 * @generated from protobuf message ListPermissionGroupsResponse
 */
export interface ListPermissionGroupsResponse {
    /**
     * @generated from protobuf field: repeated PermissionGroupResponse groups = 1;
     */
    groups: PermissionGroupResponse[];
}
/**
 * @generated from protobuf message CreatePermissionGroupRequest
 */
export interface CreatePermissionGroupRequest {
    /**
     * @generated from protobuf field: string customerID = 1;
     */
    customerID: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: bool accessEverything = 4;
     */
    accessEverything: boolean;
    /**
     * @generated from protobuf field: repeated string rooms = 5;
     */
    rooms: string[];
    /**
     * @generated from protobuf field: repeated string desks = 6;
     */
    desks: string[];
    /**
     * @generated from protobuf field: repeated string locations = 7;
     */
    locations: string[];
    /**
     * @generated from protobuf field: repeated string members = 8;
     */
    members: string[];
    /**
     * @generated from protobuf field: bool deskBookingEnabled = 9;
     */
    deskBookingEnabled: boolean;
    /**
     * @generated from protobuf field: bool roomBookingEnabled = 10;
     */
    roomBookingEnabled: boolean;
}
/**
 * @generated from protobuf message UpdatePermissionGroupRequest
 */
export interface UpdatePermissionGroupRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string customerId = 2;
     */
    customerId: string;
    /**
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: bool accessEverything = 5;
     */
    accessEverything: boolean;
    /**
     * @generated from protobuf field: repeated string rooms = 6;
     */
    rooms: string[];
    /**
     * @generated from protobuf field: repeated string desks = 7;
     */
    desks: string[];
    /**
     * @generated from protobuf field: repeated string locations = 8;
     */
    locations: string[];
    /**
     * @generated from protobuf field: repeated string deleteMembers = 9;
     */
    deleteMembers: string[];
    /**
     * @generated from protobuf field: repeated string addMembers = 10;
     */
    addMembers: string[];
    /**
     * @generated from protobuf field: bool deskBookingEnabled = 11;
     */
    deskBookingEnabled: boolean;
    /**
     * @generated from protobuf field: bool roomBookingEnabled = 12;
     */
    roomBookingEnabled: boolean;
}
/**
 * @generated from protobuf message DeletePermissionGroupRequest
 */
export interface DeletePermissionGroupRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string customerID = 2;
     */
    customerID: string;
}
/**
 * @generated from protobuf message GetPermissionGroupRequest
 */
export interface GetPermissionGroupRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string customerID = 2;
     */
    customerID: string;
}
/**
 * @generated from protobuf message ListPermissionGroupMembersRequest
 */
export interface ListPermissionGroupMembersRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string customerID = 2;
     */
    customerID: string;
    /**
     * @generated from protobuf field: int32 page = 3;
     */
    page: number;
    /**
     * @generated from protobuf field: int32 pageSize = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string search = 5;
     */
    search: string;
}
/**
 * @generated from protobuf message PermissionGroupMember
 */
export interface PermissionGroupMember {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string email = 2;
     */
    email: string;
    /**
     * @generated from protobuf field: string firstName = 3;
     */
    firstName: string;
    /**
     * @generated from protobuf field: string lastName = 4;
     */
    lastName: string;
}
/**
 * @generated from protobuf message ListPermissionGroupMembersResponse
 */
export interface ListPermissionGroupMembersResponse {
    /**
     * @generated from protobuf field: int32 page = 1;
     */
    page: number;
    /**
     * @generated from protobuf field: int32 pageSize = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: int32 count = 3;
     */
    count: number;
    /**
     * @generated from protobuf field: repeated PermissionGroupMember members = 4;
     */
    members: PermissionGroupMember[];
}
/**
 * @generated from protobuf message ListPermissionGroupCandidatesRequest
 */
export interface ListPermissionGroupCandidatesRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string customerID = 2;
     */
    customerID: string;
    /**
     * @generated from protobuf field: int32 page = 3;
     */
    page: number;
    /**
     * @generated from protobuf field: int32 pageSize = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string search = 5;
     */
    search: string;
}
/**
 * @generated from protobuf message ListPermissionGroupCandidatesResponse
 */
export interface ListPermissionGroupCandidatesResponse {
    /**
     * @generated from protobuf field: int32 page = 1;
     */
    page: number;
    /**
     * @generated from protobuf field: int32 pageSize = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: int32 count = 3;
     */
    count: number;
    /**
     * @generated from protobuf field: repeated PermissionGroupMember candidates = 4;
     */
    candidates: PermissionGroupMember[];
}
/**
 * @generated from protobuf message GetCustomerPermissionsRequest
 */
export interface GetCustomerPermissionsRequest {
    /**
     * @generated from protobuf field: string customerID = 1;
     */
    customerID: string;
    /**
     * @generated from protobuf field: string accountID = 2;
     */
    accountID: string;
}
/**
 * @generated from protobuf message CheckPermissionRequest
 */
export interface CheckPermissionRequest {
    /**
     * @generated from protobuf field: string user = 1;
     */
    user: string;
    /**
     * @generated from protobuf field: string relation = 2;
     */
    relation: string;
    /**
     * @generated from protobuf field: string object = 3;
     */
    object: string;
}
/**
 * @generated from protobuf message CheckPermissionResponse
 */
export interface CheckPermissionResponse {
    /**
     * @generated from protobuf field: bool allowed = 1;
     */
    allowed: boolean;
}
/**
 * @generated from protobuf message GetCustomerPermissionsResponse
 */
export interface GetCustomerPermissionsResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * RDX features
     *
     * @generated from protobuf field: bool backgroundImage = 2;
     */
    backgroundImage: boolean;
    /**
     * @generated from protobuf field: bool logoImage = 3;
     */
    logoImage: boolean;
    /**
     * @generated from protobuf field: bool contactlessQRBooking = 4;
     */
    contactlessQRBooking: boolean;
    /**
     * @generated from protobuf field: bool nearbyRooms = 5;
     */
    nearbyRooms: boolean;
    /**
     * @generated from protobuf field: bool equipmentReport = 6;
     */
    equipmentReport: boolean;
    /**
     * @generated from protobuf field: bool pinCode = 7;
     */
    pinCode: boolean;
    /**
     * @generated from protobuf field: bool mapView = 8;
     */
    mapView: boolean;
    /**
     * @generated from protobuf field: bool requireHeadcount = 9;
     */
    requireHeadcount: boolean;
    /**
     * @generated from protobuf field: bool onScreenReservation = 10;
     */
    onScreenReservation: boolean;
    /**
     * @generated from protobuf field: bool checkInRequired = 11;
     */
    checkInRequired: boolean;
    /**
     * Desk reservation
     *
     * @generated from protobuf field: bool usersSection = 12;
     */
    usersSection: boolean;
    /**
     * Dashboard
     *
     * @generated from protobuf field: bool officeMaps = 13;
     */
    officeMaps: boolean;
    /**
     * @generated from protobuf field: uint32 maxIntegrations = 14;
     */
    maxIntegrations: number;
    /**
     * @generated from protobuf field: uint32 maxAdminUsers = 15;
     */
    maxAdminUsers: number;
    /**
     * @generated from protobuf field: bool users = 16;
     */
    users: boolean;
    /**
     * Workplace Insights
     *
     * @generated from protobuf field: bool basicStatistic = 17;
     */
    basicStatistic: boolean;
    /**
     * @generated from protobuf field: bool advancedStatistic = 18;
     */
    advancedStatistic: boolean;
    /**
     * @generated from protobuf field: bool downloadReports = 19;
     */
    downloadReports: boolean;
    /**
     * Support
     *
     * @generated from protobuf field: bool supportByTicket = 20;
     */
    supportByTicket: boolean;
    /**
     * @generated from protobuf field: bool dedicatedSupportAgent = 21;
     */
    dedicatedSupportAgent: boolean;
    /**
     * @generated from protobuf field: bool dedicatedAccountManager = 22;
     */
    dedicatedAccountManager: boolean;
    /**
     * Security
     *
     * @generated from protobuf field: bool basicAuth = 23;
     */
    basicAuth: boolean;
    /**
     * @generated from protobuf field: bool ssoEnabled = 24;
     */
    ssoEnabled: boolean;
    /**
     * @generated from protobuf field: bool modernAuth = 25;
     */
    modernAuth: boolean;
    /**
     * @generated from protobuf field: repeated UserPermissions permissions = 26;
     */
    permissions: UserPermissions[];
    /**
     * Rooms
     *
     * @generated from protobuf field: repeated string rooms = 27;
     */
    rooms: string[];
    /**
     * Desks
     *
     * @generated from protobuf field: repeated string desks = 28;
     */
    desks: string[];
    /**
     * @generated from protobuf field: bool accessEverything = 29;
     */
    accessEverything: boolean;
    /**
     * @generated from protobuf field: bool inGroup = 30;
     */
    inGroup: boolean;
    /**
     * @generated from protobuf field: bool deskBookingEnabled = 31;
     */
    deskBookingEnabled: boolean;
    /**
     * @generated from protobuf field: bool roomBookingEnabled = 32;
     */
    roomBookingEnabled: boolean;
}
/**
 * @generated from protobuf message MigrationResponse
 */
export interface MigrationResponse {
    /**
     * @generated from protobuf field: string result = 1;
     */
    result: string;
}
/**
 * @generated from protobuf message DeletePermissionAccountRequest
 */
export interface DeletePermissionAccountRequest {
    /**
     * @generated from protobuf field: string customer_id = 1;
     */
    customerId: string;
    /**
     * @generated from protobuf field: string account_id = 2;
     */
    accountId: string;
    /**
     * @generated from protobuf field: string role = 3;
     */
    role: string;
}
/**
 * @generated from protobuf message DeletePermissionRoomRequest
 */
export interface DeletePermissionRoomRequest {
    /**
     * @generated from protobuf field: string room_id = 1;
     */
    roomId: string;
    /**
     * @generated from protobuf field: string customer_id = 2;
     */
    customerId: string;
}
/**
 * @generated from protobuf message DeletePermissionDeskRequest
 */
export interface DeletePermissionDeskRequest {
    /**
     * @generated from protobuf field: string desk_id = 1;
     */
    deskId: string;
    /**
     * @generated from protobuf field: string customer_id = 2;
     */
    customerId: string;
}
/**
 * @generated from protobuf message CreatePermissionAccountRequest
 */
export interface CreatePermissionAccountRequest {
    /**
     * @generated from protobuf field: string customer_id = 1;
     */
    customerId: string;
    /**
     * @generated from protobuf field: string account_id = 2;
     */
    accountId: string;
    /**
     * @generated from protobuf field: string role = 3;
     */
    role: string;
}
/**
 * @generated from protobuf message UpdatePermissionAccountRequest
 */
export interface UpdatePermissionAccountRequest {
    /**
     * @generated from protobuf field: string customer_id = 1;
     */
    customerId: string;
    /**
     * @generated from protobuf field: string account_id = 2;
     */
    accountId: string;
    /**
     * @generated from protobuf field: string oldRole = 3;
     */
    oldRole: string;
    /**
     * @generated from protobuf field: string newRole = 4;
     */
    newRole: string;
}
/**
 * @generated from protobuf enum UserPermissions
 */
export enum UserPermissions {
    /**
     * @generated from protobuf enum value: DASHBOARD_ACCOUNT_VIEW = 0;
     */
    DASHBOARD_ACCOUNT_VIEW = 0,
    /**
     * @generated from protobuf enum value: DASHBOARD_HELP_CENTER = 1;
     */
    DASHBOARD_HELP_CENTER = 1,
    /**
     * @generated from protobuf enum value: DASHBOARD_LEAVE_FEEDBACK = 2;
     */
    DASHBOARD_LEAVE_FEEDBACK = 2,
    /**
     * @generated from protobuf enum value: DASHBOARD_LOGOUT = 3;
     */
    DASHBOARD_LOGOUT = 3,
    /**
     * @generated from protobuf enum value: DASHBOARD_VIEW_EDIT = 4;
     */
    DASHBOARD_VIEW_EDIT = 4,
    /**
     * @generated from protobuf enum value: INSIGHTS_DESK_EXPORT_CSV = 5;
     */
    INSIGHTS_DESK_EXPORT_CSV = 5,
    /**
     * @generated from protobuf enum value: INSIGHTS_DESK_VIEW = 6;
     */
    INSIGHTS_DESK_VIEW = 6,
    /**
     * @generated from protobuf enum value: INSIGHTS_ROOM_EXPORT_CSV = 7;
     */
    INSIGHTS_ROOM_EXPORT_CSV = 7,
    /**
     * @generated from protobuf enum value: INSIGHTS_ROOM_VIEW = 8;
     */
    INSIGHTS_ROOM_VIEW = 8,
    /**
     * @generated from protobuf enum value: MANAGE_CALENDARS_VIEW_EDIT = 9;
     */
    MANAGE_CALENDARS_VIEW_EDIT = 9,
    /**
     * @generated from protobuf enum value: MANAGE_DEVICES_VIEW_EDIT = 10;
     */
    MANAGE_DEVICES_VIEW_EDIT = 10,
    /**
     * @generated from protobuf enum value: MANAGE_MAPS_VIEW_EDIT = 11;
     */
    MANAGE_MAPS_VIEW_EDIT = 11,
    /**
     * @generated from protobuf enum value: MANAGE_WORKSPACES_VIEW_EDIT = 12;
     */
    MANAGE_WORKSPACES_VIEW_EDIT = 12,
    /**
     * @generated from protobuf enum value: ORG_SETTINGS_BILLING_VIEW_EDIT = 13;
     */
    ORG_SETTINGS_BILLING_VIEW_EDIT = 13,
    /**
     * @generated from protobuf enum value: ORG_SETTINGS_GENERAL_VIEW_EDIT = 14;
     */
    ORG_SETTINGS_GENERAL_VIEW_EDIT = 14,
    /**
     * @generated from protobuf enum value: ORG_SETTINGS_SUBS_VIEW_EDIT = 15;
     */
    ORG_SETTINGS_SUBS_VIEW_EDIT = 15,
    /**
     * @generated from protobuf enum value: ORG_SETTINGS_TEMPLATES_VIEW_EDIT = 16;
     */
    ORG_SETTINGS_TEMPLATES_VIEW_EDIT = 16,
    /**
     * @generated from protobuf enum value: PROFILE_PICTURE_ADD_EDIT = 17;
     */
    PROFILE_PICTURE_ADD_EDIT = 17,
    /**
     * @generated from protobuf enum value: PROFILE_TWO_FACTOR_AUTH_ADD = 18;
     */
    PROFILE_TWO_FACTOR_AUTH_ADD = 18,
    /**
     * @generated from protobuf enum value: PROFILE_VIEW_EDIT = 19;
     */
    PROFILE_VIEW_EDIT = 19,
    /**
     * @generated from protobuf enum value: RSRVNS_ALL_EDIT = 20;
     */
    RSRVNS_ALL_EDIT = 20,
    /**
     * @generated from protobuf enum value: RSRVNS_ALL_VIEW = 21;
     */
    RSRVNS_ALL_VIEW = 21,
    /**
     * @generated from protobuf enum value: RSRVNS_CRDNTR_OWN_STL_BKNG_MDLS_VW = 22;
     */
    RSRVNS_CRDNTR_OWN_STL_BKNG_MDLS_VW = 22,
    /**
     * @generated from protobuf enum value: RSRVNS_CRDNTR_OWNER_STYLE_VIEW = 23;
     */
    RSRVNS_CRDNTR_OWNER_STYLE_VIEW = 23,
    /**
     * @generated from protobuf enum value: RSRVNS_DESK_EVENTS_DROPDOWN_EDIT = 24;
     */
    RSRVNS_DESK_EVENTS_DROPDOWN_EDIT = 24,
    /**
     * @generated from protobuf enum value: RSRVNS_DESK_EVENTS_DROPDOWN_VIEW = 25;
     */
    RSRVNS_DESK_EVENTS_DROPDOWN_VIEW = 25,
    /**
     * @generated from protobuf enum value: RSRVNS_EVENT_BEHALF_CREATE = 26;
     */
    RSRVNS_EVENT_BEHALF_CREATE = 26,
    /**
     * @generated from protobuf enum value: RSRVNS_MMBR_STL_BKNG_MDLS_VW = 27;
     */
    RSRVNS_MMBR_STL_BKNG_MDLS_VW = 27,
    /**
     * @generated from protobuf enum value: RSRVNS_MEMBER_STYLE_VIEW = 28;
     */
    RSRVNS_MEMBER_STYLE_VIEW = 28,
    /**
     * @generated from protobuf enum value: RSRVNS_ROOM_EVENTS_DROPDOWN_EDIT = 29;
     */
    RSRVNS_ROOM_EVENTS_DROPDOWN_EDIT = 29,
    /**
     * @generated from protobuf enum value: RSRVNS_ROOM_EVENTS_DROPDOWN_VIEW = 30;
     */
    RSRVNS_ROOM_EVENTS_DROPDOWN_VIEW = 30,
    /**
     * @generated from protobuf enum value: RESERVE_ALL_RSRVNS_VIEW = 31;
     */
    RESERVE_ALL_RSRVNS_VIEW = 31,
    /**
     * @generated from protobuf enum value: RESERVE_FIND_AND_RESERVE_VIEW_EDIT = 32;
     */
    RESERVE_FIND_AND_RESERVE_VIEW_EDIT = 32,
    /**
     * @generated from protobuf enum value: RESERVE_MAP_VIEW = 33;
     */
    RESERVE_MAP_VIEW = 33,
    /**
     * @generated from protobuf enum value: RESERVE_MY_RSRVNS_VIEW_EDIT = 34;
     */
    RESERVE_MY_RSRVNS_VIEW_EDIT = 34,
    /**
     * @generated from protobuf enum value: RESERVE_SETTINGS_VIEW_EDIT = 35;
     */
    RESERVE_SETTINGS_VIEW_EDIT = 35,
    /**
     * @generated from protobuf enum value: USERS_DIR_SYNC_VIEW_EDIT = 36;
     */
    USERS_DIR_SYNC_VIEW_EDIT = 36,
    /**
     * @generated from protobuf enum value: USERS_PEOPLE_VIEW_EDIT = 37;
     */
    USERS_PEOPLE_VIEW_EDIT = 37,
    /**
     * @generated from protobuf enum value: USERS_TEAMS_VIEW_EDIT = 38;
     */
    USERS_TEAMS_VIEW_EDIT = 38,
    /**
     * @generated from protobuf enum value: MODALS_TIMEZONE_SELECTOR_VIEW_EDIT = 39;
     */
    MODALS_TIMEZONE_SELECTOR_VIEW_EDIT = 39,
    /**
     * @generated from protobuf enum value: TEAMS_ACCESS = 40;
     */
    TEAMS_ACCESS = 40
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateDefaultPermissionGroupRequest$Type extends MessageType<CreateDefaultPermissionGroupRequest> {
    constructor() {
        super("CreateDefaultPermissionGroupRequest", [
            { no: 1, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateDefaultPermissionGroupRequest>): CreateDefaultPermissionGroupRequest {
        const message = { customerID: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CreateDefaultPermissionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateDefaultPermissionGroupRequest): CreateDefaultPermissionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customerID */ 1:
                    message.customerID = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateDefaultPermissionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string customerID = 1; */
        if (message.customerID !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerID);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateDefaultPermissionGroupRequest
 */
export const CreateDefaultPermissionGroupRequest = new CreateDefaultPermissionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermissionGroupResponse$Type extends MessageType<PermissionGroupResponse> {
    constructor() {
        super("PermissionGroupResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "accessEverything", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "isDefault", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "rooms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "desks", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "locations", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 11, name: "updatedAt", kind: "message", T: () => Timestamp },
            { no: 12, name: "deskBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "roomBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PermissionGroupResponse>): PermissionGroupResponse {
        const message = { id: "", customerID: "", name: "", description: "", accessEverything: false, isDefault: false, rooms: [], desks: [], locations: [], deskBookingEnabled: false, roomBookingEnabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PermissionGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PermissionGroupResponse): PermissionGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customerID */ 2:
                    message.customerID = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* bool accessEverything */ 5:
                    message.accessEverything = reader.bool();
                    break;
                case /* bool isDefault */ 6:
                    message.isDefault = reader.bool();
                    break;
                case /* repeated string rooms */ 7:
                    message.rooms.push(reader.string());
                    break;
                case /* repeated string desks */ 8:
                    message.desks.push(reader.string());
                    break;
                case /* repeated string locations */ 9:
                    message.locations.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp createdAt */ 10:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* bool deskBookingEnabled */ 12:
                    message.deskBookingEnabled = reader.bool();
                    break;
                case /* bool roomBookingEnabled */ 13:
                    message.roomBookingEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PermissionGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customerID = 2; */
        if (message.customerID !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerID);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* bool accessEverything = 5; */
        if (message.accessEverything !== false)
            writer.tag(5, WireType.Varint).bool(message.accessEverything);
        /* bool isDefault = 6; */
        if (message.isDefault !== false)
            writer.tag(6, WireType.Varint).bool(message.isDefault);
        /* repeated string rooms = 7; */
        for (let i = 0; i < message.rooms.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.rooms[i]);
        /* repeated string desks = 8; */
        for (let i = 0; i < message.desks.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.desks[i]);
        /* repeated string locations = 9; */
        for (let i = 0; i < message.locations.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.locations[i]);
        /* google.protobuf.Timestamp createdAt = 10; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool deskBookingEnabled = 12; */
        if (message.deskBookingEnabled !== false)
            writer.tag(12, WireType.Varint).bool(message.deskBookingEnabled);
        /* bool roomBookingEnabled = 13; */
        if (message.roomBookingEnabled !== false)
            writer.tag(13, WireType.Varint).bool(message.roomBookingEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermissionGroupResponse
 */
export const PermissionGroupResponse = new PermissionGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkplaceLocation$Type extends MessageType<WorkplaceLocation> {
    constructor() {
        super("WorkplaceLocation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkplaceLocation>): WorkplaceLocation {
        const message = { id: "", name: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<WorkplaceLocation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkplaceLocation): WorkplaceLocation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkplaceLocation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message WorkplaceLocation
 */
export const WorkplaceLocation = new WorkplaceLocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermissionGroupDetailedResponse$Type extends MessageType<PermissionGroupDetailedResponse> {
    constructor() {
        super("PermissionGroupDetailedResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "accessEverything", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "isDefault", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "rooms", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => WorkplaceLocation },
            { no: 8, name: "desks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => WorkplaceLocation },
            { no: 9, name: "locations", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => WorkplaceLocation },
            { no: 10, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 11, name: "updatedAt", kind: "message", T: () => Timestamp },
            { no: 12, name: "deskBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "roomBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PermissionGroupDetailedResponse>): PermissionGroupDetailedResponse {
        const message = { id: "", customerID: "", name: "", description: "", accessEverything: false, isDefault: false, rooms: [], desks: [], locations: [], deskBookingEnabled: false, roomBookingEnabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PermissionGroupDetailedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PermissionGroupDetailedResponse): PermissionGroupDetailedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customerID */ 2:
                    message.customerID = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* bool accessEverything */ 5:
                    message.accessEverything = reader.bool();
                    break;
                case /* bool isDefault */ 6:
                    message.isDefault = reader.bool();
                    break;
                case /* repeated WorkplaceLocation rooms */ 7:
                    message.rooms.push(WorkplaceLocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated WorkplaceLocation desks */ 8:
                    message.desks.push(WorkplaceLocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated WorkplaceLocation locations */ 9:
                    message.locations.push(WorkplaceLocation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp createdAt */ 10:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* bool deskBookingEnabled */ 12:
                    message.deskBookingEnabled = reader.bool();
                    break;
                case /* bool roomBookingEnabled */ 13:
                    message.roomBookingEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PermissionGroupDetailedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customerID = 2; */
        if (message.customerID !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerID);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* bool accessEverything = 5; */
        if (message.accessEverything !== false)
            writer.tag(5, WireType.Varint).bool(message.accessEverything);
        /* bool isDefault = 6; */
        if (message.isDefault !== false)
            writer.tag(6, WireType.Varint).bool(message.isDefault);
        /* repeated WorkplaceLocation rooms = 7; */
        for (let i = 0; i < message.rooms.length; i++)
            WorkplaceLocation.internalBinaryWrite(message.rooms[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated WorkplaceLocation desks = 8; */
        for (let i = 0; i < message.desks.length; i++)
            WorkplaceLocation.internalBinaryWrite(message.desks[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated WorkplaceLocation locations = 9; */
        for (let i = 0; i < message.locations.length; i++)
            WorkplaceLocation.internalBinaryWrite(message.locations[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp createdAt = 10; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool deskBookingEnabled = 12; */
        if (message.deskBookingEnabled !== false)
            writer.tag(12, WireType.Varint).bool(message.deskBookingEnabled);
        /* bool roomBookingEnabled = 13; */
        if (message.roomBookingEnabled !== false)
            writer.tag(13, WireType.Varint).bool(message.roomBookingEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermissionGroupDetailedResponse
 */
export const PermissionGroupDetailedResponse = new PermissionGroupDetailedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionGroupsRequest$Type extends MessageType<ListPermissionGroupsRequest> {
    constructor() {
        super("ListPermissionGroupsRequest", [
            { no: 1, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListPermissionGroupsRequest>): ListPermissionGroupsRequest {
        const message = { customerID: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ListPermissionGroupsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionGroupsRequest): ListPermissionGroupsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customerID */ 1:
                    message.customerID = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionGroupsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string customerID = 1; */
        if (message.customerID !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerID);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPermissionGroupsRequest
 */
export const ListPermissionGroupsRequest = new ListPermissionGroupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionGroupsResponse$Type extends MessageType<ListPermissionGroupsResponse> {
    constructor() {
        super("ListPermissionGroupsResponse", [
            { no: 1, name: "groups", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PermissionGroupResponse }
        ]);
    }
    create(value?: PartialMessage<ListPermissionGroupsResponse>): ListPermissionGroupsResponse {
        const message = { groups: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ListPermissionGroupsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionGroupsResponse): ListPermissionGroupsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermissionGroupResponse groups */ 1:
                    message.groups.push(PermissionGroupResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionGroupsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated PermissionGroupResponse groups = 1; */
        for (let i = 0; i < message.groups.length; i++)
            PermissionGroupResponse.internalBinaryWrite(message.groups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPermissionGroupsResponse
 */
export const ListPermissionGroupsResponse = new ListPermissionGroupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePermissionGroupRequest$Type extends MessageType<CreatePermissionGroupRequest> {
    constructor() {
        super("CreatePermissionGroupRequest", [
            { no: 1, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "accessEverything", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "rooms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "desks", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "locations", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "members", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "deskBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "roomBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreatePermissionGroupRequest>): CreatePermissionGroupRequest {
        const message = { customerID: "", name: "", description: "", accessEverything: false, rooms: [], desks: [], locations: [], members: [], deskBookingEnabled: false, roomBookingEnabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CreatePermissionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreatePermissionGroupRequest): CreatePermissionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customerID */ 1:
                    message.customerID = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool accessEverything */ 4:
                    message.accessEverything = reader.bool();
                    break;
                case /* repeated string rooms */ 5:
                    message.rooms.push(reader.string());
                    break;
                case /* repeated string desks */ 6:
                    message.desks.push(reader.string());
                    break;
                case /* repeated string locations */ 7:
                    message.locations.push(reader.string());
                    break;
                case /* repeated string members */ 8:
                    message.members.push(reader.string());
                    break;
                case /* bool deskBookingEnabled */ 9:
                    message.deskBookingEnabled = reader.bool();
                    break;
                case /* bool roomBookingEnabled */ 10:
                    message.roomBookingEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreatePermissionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string customerID = 1; */
        if (message.customerID !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerID);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool accessEverything = 4; */
        if (message.accessEverything !== false)
            writer.tag(4, WireType.Varint).bool(message.accessEverything);
        /* repeated string rooms = 5; */
        for (let i = 0; i < message.rooms.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.rooms[i]);
        /* repeated string desks = 6; */
        for (let i = 0; i < message.desks.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.desks[i]);
        /* repeated string locations = 7; */
        for (let i = 0; i < message.locations.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.locations[i]);
        /* repeated string members = 8; */
        for (let i = 0; i < message.members.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.members[i]);
        /* bool deskBookingEnabled = 9; */
        if (message.deskBookingEnabled !== false)
            writer.tag(9, WireType.Varint).bool(message.deskBookingEnabled);
        /* bool roomBookingEnabled = 10; */
        if (message.roomBookingEnabled !== false)
            writer.tag(10, WireType.Varint).bool(message.roomBookingEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreatePermissionGroupRequest
 */
export const CreatePermissionGroupRequest = new CreatePermissionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePermissionGroupRequest$Type extends MessageType<UpdatePermissionGroupRequest> {
    constructor() {
        super("UpdatePermissionGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "accessEverything", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "rooms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "desks", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "locations", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "deleteMembers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "addMembers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "deskBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "roomBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdatePermissionGroupRequest>): UpdatePermissionGroupRequest {
        const message = { id: "", customerId: "", name: "", description: "", accessEverything: false, rooms: [], desks: [], locations: [], deleteMembers: [], addMembers: [], deskBookingEnabled: false, roomBookingEnabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdatePermissionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePermissionGroupRequest): UpdatePermissionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customerId */ 2:
                    message.customerId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* bool accessEverything */ 5:
                    message.accessEverything = reader.bool();
                    break;
                case /* repeated string rooms */ 6:
                    message.rooms.push(reader.string());
                    break;
                case /* repeated string desks */ 7:
                    message.desks.push(reader.string());
                    break;
                case /* repeated string locations */ 8:
                    message.locations.push(reader.string());
                    break;
                case /* repeated string deleteMembers */ 9:
                    message.deleteMembers.push(reader.string());
                    break;
                case /* repeated string addMembers */ 10:
                    message.addMembers.push(reader.string());
                    break;
                case /* bool deskBookingEnabled */ 11:
                    message.deskBookingEnabled = reader.bool();
                    break;
                case /* bool roomBookingEnabled */ 12:
                    message.roomBookingEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePermissionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customerId = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* bool accessEverything = 5; */
        if (message.accessEverything !== false)
            writer.tag(5, WireType.Varint).bool(message.accessEverything);
        /* repeated string rooms = 6; */
        for (let i = 0; i < message.rooms.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.rooms[i]);
        /* repeated string desks = 7; */
        for (let i = 0; i < message.desks.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.desks[i]);
        /* repeated string locations = 8; */
        for (let i = 0; i < message.locations.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.locations[i]);
        /* repeated string deleteMembers = 9; */
        for (let i = 0; i < message.deleteMembers.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.deleteMembers[i]);
        /* repeated string addMembers = 10; */
        for (let i = 0; i < message.addMembers.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.addMembers[i]);
        /* bool deskBookingEnabled = 11; */
        if (message.deskBookingEnabled !== false)
            writer.tag(11, WireType.Varint).bool(message.deskBookingEnabled);
        /* bool roomBookingEnabled = 12; */
        if (message.roomBookingEnabled !== false)
            writer.tag(12, WireType.Varint).bool(message.roomBookingEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdatePermissionGroupRequest
 */
export const UpdatePermissionGroupRequest = new UpdatePermissionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePermissionGroupRequest$Type extends MessageType<DeletePermissionGroupRequest> {
    constructor() {
        super("DeletePermissionGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeletePermissionGroupRequest>): DeletePermissionGroupRequest {
        const message = { id: "", customerID: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeletePermissionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletePermissionGroupRequest): DeletePermissionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customerID */ 2:
                    message.customerID = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletePermissionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customerID = 2; */
        if (message.customerID !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerID);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeletePermissionGroupRequest
 */
export const DeletePermissionGroupRequest = new DeletePermissionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPermissionGroupRequest$Type extends MessageType<GetPermissionGroupRequest> {
    constructor() {
        super("GetPermissionGroupRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPermissionGroupRequest>): GetPermissionGroupRequest {
        const message = { id: "", customerID: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetPermissionGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPermissionGroupRequest): GetPermissionGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customerID */ 2:
                    message.customerID = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPermissionGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customerID = 2; */
        if (message.customerID !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerID);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPermissionGroupRequest
 */
export const GetPermissionGroupRequest = new GetPermissionGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionGroupMembersRequest$Type extends MessageType<ListPermissionGroupMembersRequest> {
    constructor() {
        super("ListPermissionGroupMembersRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "search", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListPermissionGroupMembersRequest>): ListPermissionGroupMembersRequest {
        const message = { id: "", customerID: "", page: 0, pageSize: 0, search: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ListPermissionGroupMembersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionGroupMembersRequest): ListPermissionGroupMembersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customerID */ 2:
                    message.customerID = reader.string();
                    break;
                case /* int32 page */ 3:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string search */ 5:
                    message.search = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionGroupMembersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customerID = 2; */
        if (message.customerID !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerID);
        /* int32 page = 3; */
        if (message.page !== 0)
            writer.tag(3, WireType.Varint).int32(message.page);
        /* int32 pageSize = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string search = 5; */
        if (message.search !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.search);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPermissionGroupMembersRequest
 */
export const ListPermissionGroupMembersRequest = new ListPermissionGroupMembersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermissionGroupMember$Type extends MessageType<PermissionGroupMember> {
    constructor() {
        super("PermissionGroupMember", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PermissionGroupMember>): PermissionGroupMember {
        const message = { id: "", email: "", firstName: "", lastName: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<PermissionGroupMember>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PermissionGroupMember): PermissionGroupMember {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string firstName */ 3:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 4:
                    message.lastName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PermissionGroupMember, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string firstName = 3; */
        if (message.firstName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 4; */
        if (message.lastName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermissionGroupMember
 */
export const PermissionGroupMember = new PermissionGroupMember$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionGroupMembersResponse$Type extends MessageType<ListPermissionGroupMembersResponse> {
    constructor() {
        super("ListPermissionGroupMembersResponse", [
            { no: 1, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "members", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PermissionGroupMember }
        ]);
    }
    create(value?: PartialMessage<ListPermissionGroupMembersResponse>): ListPermissionGroupMembersResponse {
        const message = { page: 0, pageSize: 0, count: 0, members: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ListPermissionGroupMembersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionGroupMembersResponse): ListPermissionGroupMembersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page */ 1:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* int32 count */ 3:
                    message.count = reader.int32();
                    break;
                case /* repeated PermissionGroupMember members */ 4:
                    message.members.push(PermissionGroupMember.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionGroupMembersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page = 1; */
        if (message.page !== 0)
            writer.tag(1, WireType.Varint).int32(message.page);
        /* int32 pageSize = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* int32 count = 3; */
        if (message.count !== 0)
            writer.tag(3, WireType.Varint).int32(message.count);
        /* repeated PermissionGroupMember members = 4; */
        for (let i = 0; i < message.members.length; i++)
            PermissionGroupMember.internalBinaryWrite(message.members[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPermissionGroupMembersResponse
 */
export const ListPermissionGroupMembersResponse = new ListPermissionGroupMembersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionGroupCandidatesRequest$Type extends MessageType<ListPermissionGroupCandidatesRequest> {
    constructor() {
        super("ListPermissionGroupCandidatesRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "search", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListPermissionGroupCandidatesRequest>): ListPermissionGroupCandidatesRequest {
        const message = { id: "", customerID: "", page: 0, pageSize: 0, search: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ListPermissionGroupCandidatesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionGroupCandidatesRequest): ListPermissionGroupCandidatesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customerID */ 2:
                    message.customerID = reader.string();
                    break;
                case /* int32 page */ 3:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string search */ 5:
                    message.search = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionGroupCandidatesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customerID = 2; */
        if (message.customerID !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerID);
        /* int32 page = 3; */
        if (message.page !== 0)
            writer.tag(3, WireType.Varint).int32(message.page);
        /* int32 pageSize = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string search = 5; */
        if (message.search !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.search);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPermissionGroupCandidatesRequest
 */
export const ListPermissionGroupCandidatesRequest = new ListPermissionGroupCandidatesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPermissionGroupCandidatesResponse$Type extends MessageType<ListPermissionGroupCandidatesResponse> {
    constructor() {
        super("ListPermissionGroupCandidatesResponse", [
            { no: 1, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "candidates", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => PermissionGroupMember }
        ]);
    }
    create(value?: PartialMessage<ListPermissionGroupCandidatesResponse>): ListPermissionGroupCandidatesResponse {
        const message = { page: 0, pageSize: 0, count: 0, candidates: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<ListPermissionGroupCandidatesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListPermissionGroupCandidatesResponse): ListPermissionGroupCandidatesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page */ 1:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* int32 count */ 3:
                    message.count = reader.int32();
                    break;
                case /* repeated PermissionGroupMember candidates */ 4:
                    message.candidates.push(PermissionGroupMember.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListPermissionGroupCandidatesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page = 1; */
        if (message.page !== 0)
            writer.tag(1, WireType.Varint).int32(message.page);
        /* int32 pageSize = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* int32 count = 3; */
        if (message.count !== 0)
            writer.tag(3, WireType.Varint).int32(message.count);
        /* repeated PermissionGroupMember candidates = 4; */
        for (let i = 0; i < message.candidates.length; i++)
            PermissionGroupMember.internalBinaryWrite(message.candidates[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPermissionGroupCandidatesResponse
 */
export const ListPermissionGroupCandidatesResponse = new ListPermissionGroupCandidatesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerPermissionsRequest$Type extends MessageType<GetCustomerPermissionsRequest> {
    constructor() {
        super("GetCustomerPermissionsRequest", [
            { no: 1, name: "customerID", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "accountID", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetCustomerPermissionsRequest>): GetCustomerPermissionsRequest {
        const message = { customerID: "", accountID: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetCustomerPermissionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerPermissionsRequest): GetCustomerPermissionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customerID */ 1:
                    message.customerID = reader.string();
                    break;
                case /* string accountID */ 2:
                    message.accountID = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerPermissionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string customerID = 1; */
        if (message.customerID !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerID);
        /* string accountID = 2; */
        if (message.accountID !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accountID);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetCustomerPermissionsRequest
 */
export const GetCustomerPermissionsRequest = new GetCustomerPermissionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckPermissionRequest$Type extends MessageType<CheckPermissionRequest> {
    constructor() {
        super("CheckPermissionRequest", [
            { no: 1, name: "user", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "relation", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "object", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CheckPermissionRequest>): CheckPermissionRequest {
        const message = { user: "", relation: "", object: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CheckPermissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckPermissionRequest): CheckPermissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user */ 1:
                    message.user = reader.string();
                    break;
                case /* string relation */ 2:
                    message.relation = reader.string();
                    break;
                case /* string object */ 3:
                    message.object = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckPermissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user = 1; */
        if (message.user !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.user);
        /* string relation = 2; */
        if (message.relation !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.relation);
        /* string object = 3; */
        if (message.object !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.object);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckPermissionRequest
 */
export const CheckPermissionRequest = new CheckPermissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckPermissionResponse$Type extends MessageType<CheckPermissionResponse> {
    constructor() {
        super("CheckPermissionResponse", [
            { no: 1, name: "allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckPermissionResponse>): CheckPermissionResponse {
        const message = { allowed: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CheckPermissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckPermissionResponse): CheckPermissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool allowed */ 1:
                    message.allowed = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckPermissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool allowed = 1; */
        if (message.allowed !== false)
            writer.tag(1, WireType.Varint).bool(message.allowed);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckPermissionResponse
 */
export const CheckPermissionResponse = new CheckPermissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerPermissionsResponse$Type extends MessageType<GetCustomerPermissionsResponse> {
    constructor() {
        super("GetCustomerPermissionsResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "backgroundImage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "logoImage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "contactlessQRBooking", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "nearbyRooms", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "equipmentReport", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "pinCode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "mapView", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "requireHeadcount", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "onScreenReservation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "checkInRequired", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "usersSection", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "officeMaps", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "maxIntegrations", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 15, name: "maxAdminUsers", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 16, name: "users", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "basicStatistic", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "advancedStatistic", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "downloadReports", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "supportByTicket", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "dedicatedSupportAgent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "dedicatedAccountManager", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "basicAuth", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "ssoEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "modernAuth", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "permissions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["UserPermissions", UserPermissions] },
            { no: 27, name: "rooms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "desks", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "accessEverything", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "inGroup", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "deskBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 32, name: "roomBookingEnabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetCustomerPermissionsResponse>): GetCustomerPermissionsResponse {
        const message = { id: "", backgroundImage: false, logoImage: false, contactlessQRBooking: false, nearbyRooms: false, equipmentReport: false, pinCode: false, mapView: false, requireHeadcount: false, onScreenReservation: false, checkInRequired: false, usersSection: false, officeMaps: false, maxIntegrations: 0, maxAdminUsers: 0, users: false, basicStatistic: false, advancedStatistic: false, downloadReports: false, supportByTicket: false, dedicatedSupportAgent: false, dedicatedAccountManager: false, basicAuth: false, ssoEnabled: false, modernAuth: false, permissions: [], rooms: [], desks: [], accessEverything: false, inGroup: false, deskBookingEnabled: false, roomBookingEnabled: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetCustomerPermissionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCustomerPermissionsResponse): GetCustomerPermissionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool backgroundImage */ 2:
                    message.backgroundImage = reader.bool();
                    break;
                case /* bool logoImage */ 3:
                    message.logoImage = reader.bool();
                    break;
                case /* bool contactlessQRBooking */ 4:
                    message.contactlessQRBooking = reader.bool();
                    break;
                case /* bool nearbyRooms */ 5:
                    message.nearbyRooms = reader.bool();
                    break;
                case /* bool equipmentReport */ 6:
                    message.equipmentReport = reader.bool();
                    break;
                case /* bool pinCode */ 7:
                    message.pinCode = reader.bool();
                    break;
                case /* bool mapView */ 8:
                    message.mapView = reader.bool();
                    break;
                case /* bool requireHeadcount */ 9:
                    message.requireHeadcount = reader.bool();
                    break;
                case /* bool onScreenReservation */ 10:
                    message.onScreenReservation = reader.bool();
                    break;
                case /* bool checkInRequired */ 11:
                    message.checkInRequired = reader.bool();
                    break;
                case /* bool usersSection */ 12:
                    message.usersSection = reader.bool();
                    break;
                case /* bool officeMaps */ 13:
                    message.officeMaps = reader.bool();
                    break;
                case /* uint32 maxIntegrations */ 14:
                    message.maxIntegrations = reader.uint32();
                    break;
                case /* uint32 maxAdminUsers */ 15:
                    message.maxAdminUsers = reader.uint32();
                    break;
                case /* bool users */ 16:
                    message.users = reader.bool();
                    break;
                case /* bool basicStatistic */ 17:
                    message.basicStatistic = reader.bool();
                    break;
                case /* bool advancedStatistic */ 18:
                    message.advancedStatistic = reader.bool();
                    break;
                case /* bool downloadReports */ 19:
                    message.downloadReports = reader.bool();
                    break;
                case /* bool supportByTicket */ 20:
                    message.supportByTicket = reader.bool();
                    break;
                case /* bool dedicatedSupportAgent */ 21:
                    message.dedicatedSupportAgent = reader.bool();
                    break;
                case /* bool dedicatedAccountManager */ 22:
                    message.dedicatedAccountManager = reader.bool();
                    break;
                case /* bool basicAuth */ 23:
                    message.basicAuth = reader.bool();
                    break;
                case /* bool ssoEnabled */ 24:
                    message.ssoEnabled = reader.bool();
                    break;
                case /* bool modernAuth */ 25:
                    message.modernAuth = reader.bool();
                    break;
                case /* repeated UserPermissions permissions */ 26:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.permissions.push(reader.int32());
                    else
                        message.permissions.push(reader.int32());
                    break;
                case /* repeated string rooms */ 27:
                    message.rooms.push(reader.string());
                    break;
                case /* repeated string desks */ 28:
                    message.desks.push(reader.string());
                    break;
                case /* bool accessEverything */ 29:
                    message.accessEverything = reader.bool();
                    break;
                case /* bool inGroup */ 30:
                    message.inGroup = reader.bool();
                    break;
                case /* bool deskBookingEnabled */ 31:
                    message.deskBookingEnabled = reader.bool();
                    break;
                case /* bool roomBookingEnabled */ 32:
                    message.roomBookingEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCustomerPermissionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool backgroundImage = 2; */
        if (message.backgroundImage !== false)
            writer.tag(2, WireType.Varint).bool(message.backgroundImage);
        /* bool logoImage = 3; */
        if (message.logoImage !== false)
            writer.tag(3, WireType.Varint).bool(message.logoImage);
        /* bool contactlessQRBooking = 4; */
        if (message.contactlessQRBooking !== false)
            writer.tag(4, WireType.Varint).bool(message.contactlessQRBooking);
        /* bool nearbyRooms = 5; */
        if (message.nearbyRooms !== false)
            writer.tag(5, WireType.Varint).bool(message.nearbyRooms);
        /* bool equipmentReport = 6; */
        if (message.equipmentReport !== false)
            writer.tag(6, WireType.Varint).bool(message.equipmentReport);
        /* bool pinCode = 7; */
        if (message.pinCode !== false)
            writer.tag(7, WireType.Varint).bool(message.pinCode);
        /* bool mapView = 8; */
        if (message.mapView !== false)
            writer.tag(8, WireType.Varint).bool(message.mapView);
        /* bool requireHeadcount = 9; */
        if (message.requireHeadcount !== false)
            writer.tag(9, WireType.Varint).bool(message.requireHeadcount);
        /* bool onScreenReservation = 10; */
        if (message.onScreenReservation !== false)
            writer.tag(10, WireType.Varint).bool(message.onScreenReservation);
        /* bool checkInRequired = 11; */
        if (message.checkInRequired !== false)
            writer.tag(11, WireType.Varint).bool(message.checkInRequired);
        /* bool usersSection = 12; */
        if (message.usersSection !== false)
            writer.tag(12, WireType.Varint).bool(message.usersSection);
        /* bool officeMaps = 13; */
        if (message.officeMaps !== false)
            writer.tag(13, WireType.Varint).bool(message.officeMaps);
        /* uint32 maxIntegrations = 14; */
        if (message.maxIntegrations !== 0)
            writer.tag(14, WireType.Varint).uint32(message.maxIntegrations);
        /* uint32 maxAdminUsers = 15; */
        if (message.maxAdminUsers !== 0)
            writer.tag(15, WireType.Varint).uint32(message.maxAdminUsers);
        /* bool users = 16; */
        if (message.users !== false)
            writer.tag(16, WireType.Varint).bool(message.users);
        /* bool basicStatistic = 17; */
        if (message.basicStatistic !== false)
            writer.tag(17, WireType.Varint).bool(message.basicStatistic);
        /* bool advancedStatistic = 18; */
        if (message.advancedStatistic !== false)
            writer.tag(18, WireType.Varint).bool(message.advancedStatistic);
        /* bool downloadReports = 19; */
        if (message.downloadReports !== false)
            writer.tag(19, WireType.Varint).bool(message.downloadReports);
        /* bool supportByTicket = 20; */
        if (message.supportByTicket !== false)
            writer.tag(20, WireType.Varint).bool(message.supportByTicket);
        /* bool dedicatedSupportAgent = 21; */
        if (message.dedicatedSupportAgent !== false)
            writer.tag(21, WireType.Varint).bool(message.dedicatedSupportAgent);
        /* bool dedicatedAccountManager = 22; */
        if (message.dedicatedAccountManager !== false)
            writer.tag(22, WireType.Varint).bool(message.dedicatedAccountManager);
        /* bool basicAuth = 23; */
        if (message.basicAuth !== false)
            writer.tag(23, WireType.Varint).bool(message.basicAuth);
        /* bool ssoEnabled = 24; */
        if (message.ssoEnabled !== false)
            writer.tag(24, WireType.Varint).bool(message.ssoEnabled);
        /* bool modernAuth = 25; */
        if (message.modernAuth !== false)
            writer.tag(25, WireType.Varint).bool(message.modernAuth);
        /* repeated UserPermissions permissions = 26; */
        if (message.permissions.length) {
            writer.tag(26, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.permissions.length; i++)
                writer.int32(message.permissions[i]);
            writer.join();
        }
        /* repeated string rooms = 27; */
        for (let i = 0; i < message.rooms.length; i++)
            writer.tag(27, WireType.LengthDelimited).string(message.rooms[i]);
        /* repeated string desks = 28; */
        for (let i = 0; i < message.desks.length; i++)
            writer.tag(28, WireType.LengthDelimited).string(message.desks[i]);
        /* bool accessEverything = 29; */
        if (message.accessEverything !== false)
            writer.tag(29, WireType.Varint).bool(message.accessEverything);
        /* bool inGroup = 30; */
        if (message.inGroup !== false)
            writer.tag(30, WireType.Varint).bool(message.inGroup);
        /* bool deskBookingEnabled = 31; */
        if (message.deskBookingEnabled !== false)
            writer.tag(31, WireType.Varint).bool(message.deskBookingEnabled);
        /* bool roomBookingEnabled = 32; */
        if (message.roomBookingEnabled !== false)
            writer.tag(32, WireType.Varint).bool(message.roomBookingEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetCustomerPermissionsResponse
 */
export const GetCustomerPermissionsResponse = new GetCustomerPermissionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MigrationResponse$Type extends MessageType<MigrationResponse> {
    constructor() {
        super("MigrationResponse", [
            { no: 1, name: "result", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<MigrationResponse>): MigrationResponse {
        const message = { result: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<MigrationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MigrationResponse): MigrationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string result */ 1:
                    message.result = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MigrationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string result = 1; */
        if (message.result !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.result);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MigrationResponse
 */
export const MigrationResponse = new MigrationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePermissionAccountRequest$Type extends MessageType<DeletePermissionAccountRequest> {
    constructor() {
        super("DeletePermissionAccountRequest", [
            { no: 1, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeletePermissionAccountRequest>): DeletePermissionAccountRequest {
        const message = { customerId: "", accountId: "", role: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeletePermissionAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletePermissionAccountRequest): DeletePermissionAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.customerId = reader.string();
                    break;
                case /* string account_id */ 2:
                    message.accountId = reader.string();
                    break;
                case /* string role */ 3:
                    message.role = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletePermissionAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string customer_id = 1; */
        if (message.customerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerId);
        /* string account_id = 2; */
        if (message.accountId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accountId);
        /* string role = 3; */
        if (message.role !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.role);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeletePermissionAccountRequest
 */
export const DeletePermissionAccountRequest = new DeletePermissionAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePermissionRoomRequest$Type extends MessageType<DeletePermissionRoomRequest> {
    constructor() {
        super("DeletePermissionRoomRequest", [
            { no: 1, name: "room_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeletePermissionRoomRequest>): DeletePermissionRoomRequest {
        const message = { roomId: "", customerId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeletePermissionRoomRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletePermissionRoomRequest): DeletePermissionRoomRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string room_id */ 1:
                    message.roomId = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletePermissionRoomRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string room_id = 1; */
        if (message.roomId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.roomId);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeletePermissionRoomRequest
 */
export const DeletePermissionRoomRequest = new DeletePermissionRoomRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletePermissionDeskRequest$Type extends MessageType<DeletePermissionDeskRequest> {
    constructor() {
        super("DeletePermissionDeskRequest", [
            { no: 1, name: "desk_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeletePermissionDeskRequest>): DeletePermissionDeskRequest {
        const message = { deskId: "", customerId: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeletePermissionDeskRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletePermissionDeskRequest): DeletePermissionDeskRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string desk_id */ 1:
                    message.deskId = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletePermissionDeskRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string desk_id = 1; */
        if (message.deskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deskId);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeletePermissionDeskRequest
 */
export const DeletePermissionDeskRequest = new DeletePermissionDeskRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePermissionAccountRequest$Type extends MessageType<CreatePermissionAccountRequest> {
    constructor() {
        super("CreatePermissionAccountRequest", [
            { no: 1, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreatePermissionAccountRequest>): CreatePermissionAccountRequest {
        const message = { customerId: "", accountId: "", role: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<CreatePermissionAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreatePermissionAccountRequest): CreatePermissionAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.customerId = reader.string();
                    break;
                case /* string account_id */ 2:
                    message.accountId = reader.string();
                    break;
                case /* string role */ 3:
                    message.role = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreatePermissionAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string customer_id = 1; */
        if (message.customerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerId);
        /* string account_id = 2; */
        if (message.accountId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accountId);
        /* string role = 3; */
        if (message.role !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.role);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreatePermissionAccountRequest
 */
export const CreatePermissionAccountRequest = new CreatePermissionAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePermissionAccountRequest$Type extends MessageType<UpdatePermissionAccountRequest> {
    constructor() {
        super("UpdatePermissionAccountRequest", [
            { no: 1, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "oldRole", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "newRole", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdatePermissionAccountRequest>): UpdatePermissionAccountRequest {
        const message = { customerId: "", accountId: "", oldRole: "", newRole: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<UpdatePermissionAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdatePermissionAccountRequest): UpdatePermissionAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.customerId = reader.string();
                    break;
                case /* string account_id */ 2:
                    message.accountId = reader.string();
                    break;
                case /* string oldRole */ 3:
                    message.oldRole = reader.string();
                    break;
                case /* string newRole */ 4:
                    message.newRole = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdatePermissionAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string customer_id = 1; */
        if (message.customerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerId);
        /* string account_id = 2; */
        if (message.accountId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accountId);
        /* string oldRole = 3; */
        if (message.oldRole !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.oldRole);
        /* string newRole = 4; */
        if (message.newRole !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.newRole);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdatePermissionAccountRequest
 */
export const UpdatePermissionAccountRequest = new UpdatePermissionAccountRequest$Type();
/**
 * @generated ServiceType for protobuf service Permissions
 */
export const Permissions = new ServiceType("Permissions", [
    { name: "Heartbeat", options: {}, I: Empty, O: Empty },
    { name: "CreateDefaultPermissionGroup", options: {}, I: CreateDefaultPermissionGroupRequest, O: PermissionGroupDetailedResponse },
    { name: "ListPermissionGroups", options: {}, I: ListPermissionGroupsRequest, O: ListPermissionGroupsResponse },
    { name: "CreatePermissionGroup", options: {}, I: CreatePermissionGroupRequest, O: PermissionGroupDetailedResponse },
    { name: "UpdatePermissionGroup", options: {}, I: UpdatePermissionGroupRequest, O: PermissionGroupDetailedResponse },
    { name: "DeletePermissionGroup", options: {}, I: DeletePermissionGroupRequest, O: Empty },
    { name: "GetPermissionGroup", options: {}, I: GetPermissionGroupRequest, O: PermissionGroupDetailedResponse },
    { name: "ListPermissionGroupMembers", options: {}, I: ListPermissionGroupMembersRequest, O: ListPermissionGroupMembersResponse },
    { name: "ListPermissionGroupCandidates", options: {}, I: ListPermissionGroupCandidatesRequest, O: ListPermissionGroupCandidatesResponse },
    { name: "GetCustomerPermissions", options: {}, I: GetCustomerPermissionsRequest, O: GetCustomerPermissionsResponse },
    { name: "CheckPermission", options: {}, I: CheckPermissionRequest, O: CheckPermissionResponse },
    { name: "Migration", options: {}, I: Empty, O: MigrationResponse },
    { name: "Sync", options: {}, I: Empty, O: Empty },
    { name: "DeleteAccount", options: {}, I: DeletePermissionAccountRequest, O: Empty },
    { name: "DeleteDesk", options: {}, I: DeletePermissionDeskRequest, O: Empty },
    { name: "DeleteRoom", options: {}, I: DeletePermissionRoomRequest, O: Empty },
    { name: "CreatePermissionAccount", options: {}, I: CreatePermissionAccountRequest, O: Empty },
    { name: "UpdatePermissionAccount", options: {}, I: UpdatePermissionAccountRequest, O: Empty }
]);
